import { createAiCoreClient } from '@kanbu/shared';

import { AppSettings } from '@/constants';

export const aiCoreClient = createAiCoreClient({
  prefixUrl: AppSettings.apiUrl,
});
